export function normalizeOptions({ options, refine }) {
  return options.map(option => ({
    name: option.label,
    handleOnClick: () => !option.disabled && refine(option.value),
    active: option.isRefined,
    disabled: option.disabled,
  }));
}
